// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Privacy Mode Dropdown Styles */

.privacy-mode-dropdown {
  position: relative;
  display: flex;
  align-items: center;
  margin-right: 8px; /* Add space between privacy dropdown and notification bell */
}

.privacy-mode-trigger {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 8px;
  color: #2c3e50;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 14px;
  font-weight: 500;
  min-width: auto;
  justify-content: center;
  backdrop-filter: blur(10px);
}

.privacy-mode-trigger:hover {
  background: rgba(255, 255, 255, 0.95);
  border-color: rgba(255, 255, 255, 0.5);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.privacy-mode-trigger.active {
  background: white;
  border-color: #e9ecef;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 120px;
  justify-content: space-between;
}

.privacy-mode-trigger:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.privacy-icon {
  font-size: 16px;
}

.privacy-label {
  flex: 1 1;
  text-align: left;
  color: #2c3e50;
  font-weight: 500;
}

.privacy-arrow {
  transition: transform 0.2s ease;
  opacity: 0.7;
}

.privacy-arrow.open {
  transform: rotate(180deg);
}

.privacy-spinner {
  font-size: 12px;
  animation: spin 1s linear infinite;
}

/* Dropdown Menu */
.privacy-mode-menu {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 8px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
  border: 1px solid #e9ecef;
  min-width: 280px;
  z-index: 10001;
  animation: slideDown 0.2s ease-out;
  overflow: hidden;
}

.privacy-mode-header {
  padding: 16px 20px;
  border-bottom: 1px solid #f0f0f0;
  background: #f8f9fa;
}

.privacy-mode-header h4 {
  margin: 0 0 4px 0;
  font-size: 18px;
  font-weight: 600;
  color: #2c3e50;
}

.privacy-mode-header p {
  margin: 0;
  font-size: 14px;
  color: #6c757d;
}

.privacy-mode-options {
  padding: 8px 0;
}

.privacy-mode-option {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 20px;
  border: none;
  background: none;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: left;
}

.privacy-mode-option:hover {
  background: #f8f9fa;
}

.privacy-mode-option.active {
  background: linear-gradient(90deg, #e3f2fd 0%, #f8f9fa 100%);
  border-left: 4px solid #007bff;
}

.privacy-mode-option:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.privacy-option-icon {
  font-size: 20px;
  width: 24px;
  text-align: center;
}

.privacy-option-content {
  flex: 1 1;
}

.privacy-option-label {
  font-weight: 600;
  color: #2c3e50;
  font-size: 14px;
  margin-bottom: 2px;
}

.privacy-option-description {
  font-size: 12px;
  color: #6c757d;
  line-height: 1.3;
}

.privacy-option-check {
  color: #007bff;
  font-weight: 600;
  font-size: 16px;
}

.privacy-mode-note {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 12px 20px;
  background: #f8f9fa;
  border-top: 1px solid #f0f0f0;
  font-size: 12px;
  color: #6c757d;
  line-height: 1.4;
}

.privacy-note-icon {
  font-size: 14px;
  margin-top: 1px;
}

/* Animations */
@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* Mobile Responsive */
@media (max-width: 768px) {
  .privacy-mode-trigger {
    padding: 6px 10px;
    font-size: 13px;
  }

  .privacy-icon {
    font-size: 14px;
  }

  .privacy-mode-menu {
    min-width: 260px;
    right: -20px; /* Adjust for mobile */
  }

  .privacy-mode-header {
    padding: 14px 16px;
  }

  .privacy-mode-option {
    padding: 10px 16px;
  }

  .privacy-mode-note {
    padding: 10px 16px;
  }
}

@media (max-width: 480px) {
  .privacy-mode-trigger {
    padding: 6px 8px;
    font-size: 12px;
  }

  .privacy-label {
    display: none; /* Hide label on very small screens, show only icon */
  }

  .privacy-mode-menu {
    min-width: 240px;
    right: -40px;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/PrivacyModeDropdown.css"],"names":[],"mappings":"AAAA,iCAAiC;;AAEjC;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,iBAAiB,EAAE,6DAA6D;AAClF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oCAAoC;EACpC,0CAA0C;EAC1C,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;EACtC,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,0CAA0C;EAC1C,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,kCAAkC;AACpC;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,4DAA4D;EAC5D,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA,eAAe;AACf;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,YAAY,EAAE,sBAAsB;EACtC;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,aAAa,EAAE,qDAAqD;EACtE;;EAEA;IACE,gBAAgB;IAChB,YAAY;EACd;AACF","sourcesContent":["/* Privacy Mode Dropdown Styles */\n\n.privacy-mode-dropdown {\n  position: relative;\n  display: flex;\n  align-items: center;\n  margin-right: 8px; /* Add space between privacy dropdown and notification bell */\n}\n\n.privacy-mode-trigger {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n  background: rgba(255, 255, 255, 0.9);\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  border-radius: 8px;\n  color: #2c3e50;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-size: 14px;\n  font-weight: 500;\n  min-width: auto;\n  justify-content: center;\n  backdrop-filter: blur(10px);\n}\n\n.privacy-mode-trigger:hover {\n  background: rgba(255, 255, 255, 0.95);\n  border-color: rgba(255, 255, 255, 0.5);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.privacy-mode-trigger.active {\n  background: white;\n  border-color: #e9ecef;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  min-width: 120px;\n  justify-content: space-between;\n}\n\n.privacy-mode-trigger:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.privacy-icon {\n  font-size: 16px;\n}\n\n.privacy-label {\n  flex: 1;\n  text-align: left;\n  color: #2c3e50;\n  font-weight: 500;\n}\n\n.privacy-arrow {\n  transition: transform 0.2s ease;\n  opacity: 0.7;\n}\n\n.privacy-arrow.open {\n  transform: rotate(180deg);\n}\n\n.privacy-spinner {\n  font-size: 12px;\n  animation: spin 1s linear infinite;\n}\n\n/* Dropdown Menu */\n.privacy-mode-menu {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  margin-top: 8px;\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);\n  border: 1px solid #e9ecef;\n  min-width: 280px;\n  z-index: 10001;\n  animation: slideDown 0.2s ease-out;\n  overflow: hidden;\n}\n\n.privacy-mode-header {\n  padding: 16px 20px;\n  border-bottom: 1px solid #f0f0f0;\n  background: #f8f9fa;\n}\n\n.privacy-mode-header h4 {\n  margin: 0 0 4px 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: #2c3e50;\n}\n\n.privacy-mode-header p {\n  margin: 0;\n  font-size: 14px;\n  color: #6c757d;\n}\n\n.privacy-mode-options {\n  padding: 8px 0;\n}\n\n.privacy-mode-option {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 20px;\n  border: none;\n  background: none;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  text-align: left;\n}\n\n.privacy-mode-option:hover {\n  background: #f8f9fa;\n}\n\n.privacy-mode-option.active {\n  background: linear-gradient(90deg, #e3f2fd 0%, #f8f9fa 100%);\n  border-left: 4px solid #007bff;\n}\n\n.privacy-mode-option:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.privacy-option-icon {\n  font-size: 20px;\n  width: 24px;\n  text-align: center;\n}\n\n.privacy-option-content {\n  flex: 1;\n}\n\n.privacy-option-label {\n  font-weight: 600;\n  color: #2c3e50;\n  font-size: 14px;\n  margin-bottom: 2px;\n}\n\n.privacy-option-description {\n  font-size: 12px;\n  color: #6c757d;\n  line-height: 1.3;\n}\n\n.privacy-option-check {\n  color: #007bff;\n  font-weight: 600;\n  font-size: 16px;\n}\n\n.privacy-mode-note {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  padding: 12px 20px;\n  background: #f8f9fa;\n  border-top: 1px solid #f0f0f0;\n  font-size: 12px;\n  color: #6c757d;\n  line-height: 1.4;\n}\n\n.privacy-note-icon {\n  font-size: 14px;\n  margin-top: 1px;\n}\n\n/* Animations */\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Mobile Responsive */\n@media (max-width: 768px) {\n  .privacy-mode-trigger {\n    padding: 6px 10px;\n    font-size: 13px;\n  }\n\n  .privacy-icon {\n    font-size: 14px;\n  }\n\n  .privacy-mode-menu {\n    min-width: 260px;\n    right: -20px; /* Adjust for mobile */\n  }\n\n  .privacy-mode-header {\n    padding: 14px 16px;\n  }\n\n  .privacy-mode-option {\n    padding: 10px 16px;\n  }\n\n  .privacy-mode-note {\n    padding: 10px 16px;\n  }\n}\n\n@media (max-width: 480px) {\n  .privacy-mode-trigger {\n    padding: 6px 8px;\n    font-size: 12px;\n  }\n\n  .privacy-label {\n    display: none; /* Hide label on very small screens, show only icon */\n  }\n\n  .privacy-mode-menu {\n    min-width: 240px;\n    right: -40px;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
